import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ErrorMessage } from '../../../../../common/models/enums/error-message';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { StaticSites } from '../models/static-sites';
import { StaticSitesFormValues } from '../models/static-sites-form-values';
import { staticSitesDetailRequestSelector } from './static-sites-detail-selectors';

export const STATIC_SITES_DETAIL_FETCH = 'STATIC_SITES_DETAIL_FETCH';
export const STATIC_SITES_DETAIL_RESET = 'STATIC_SITES_DETAIL_RESET';
export const STATIC_SITES_DETAIL_CREATE = 'STATIC_SITES_DETAIL_CREATE';
export const STATIC_SITES_DETAIL_UPDATE = 'STATIC_SITES_DETAIL_UPDATE';
export const STATIC_SITES_DETAIL_RECEIVE = 'STATIC_SITES_DETAIL_RECEIVE';
export const STATIC_SITES_DETAIL_RECEIVE_NON_UNIQUE_PROPERTIES = 'STATIC_SITES_DETAIL_RECEIVE_NON_UNIQUE_PROPERTIES';
export const STATIC_SITES_DETAIL_ERROR = 'STATIC_SITES_DETAIL_ERROR';

const receiveStaticSitesDetail = (staticSites: StaticSites) => {
    return {
        type: STATIC_SITES_DETAIL_RECEIVE,
        staticSites,
    };
};

const staticSitesDetailError = () => {
    return {
        type: STATIC_SITES_DETAIL_ERROR,
    };
};

const receiveNonUniquePropertiesError = () => {
    return {
        type: STATIC_SITES_DETAIL_RECEIVE_NON_UNIQUE_PROPERTIES,
    };
};

export const resetStaticSitesDetail = () => {
    return {
        type: STATIC_SITES_DETAIL_RESET,
    };
};

export const fetchStaticSitesDetail = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: STATIC_SITES_DETAIL_FETCH });

        const response = await api.contentManagement.StaticSites.StaticSitesDetail.getStaticSitesDetail(id);

        if (response.success) {
            dispatch(receiveStaticSitesDetail(response.result));
        } else {
            dispatch(staticSitesDetailError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveStaticSitesDetail = (values: StaticSitesFormValues) => {
    return async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        const staticSites = staticSitesDetailRequestSelector(values)(getState());

        let response: ApiResult<StaticSites> | null = null;
        if (staticSites.id) {
            dispatch({ type: STATIC_SITES_DETAIL_UPDATE });
            response = await api.contentManagement.StaticSites.StaticSitesDetail.updateStaticSitesDetail(staticSites);
        } else {
            dispatch({ type: STATIC_SITES_DETAIL_CREATE });
            response = await api.contentManagement.StaticSites.StaticSitesDetail.createStaticSitesDetail(staticSites);
        }

        if (response.success) {
            dispatch(receiveStaticSitesDetail(response.result));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.staticSitesSaved')));
        } else {
            if (response.error?.title === ErrorMessage.NonUniqueProperties) {
                dispatch(receiveNonUniquePropertiesError());
                return;
            }
            dispatch(staticSitesDetailError());
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
